import { message } from "antd";
import React from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { getCategory, putCategory } from "../../../helpers/api";
import _ from "lodash";
import { RequiredIndicator } from "../../../components";
import smallTalk from "smalltalk";

export default function EditCategoryForm({ onSuccess, id }) {
  const { handleSubmit, register, reset, watch, setValue } = useForm();

  // Fetch category data
  const { data: category, isLoading: isFetching } = useQuery({
    queryFn: () => getCategory(id),
    queryKey: ["category", id],
    enabled: !!id,
    onSuccess: (data) => {
      if (data) {
        setValue("title", data.title);
        setValue("description", data.description);
        setValue("type", data.type);
      }
    },
  });

  const { mutateAsync, isLoading } = useMutation(
    (data) => putCategory(id, data),
    {
      onSuccess: (data, variables, context) => {
        if (data.status === 200) {
          message.success("Category updated successfully");
          onSuccess();
          return;
        }
        throw data;
      },
      onError: (error, variables, context) => {
        const err = error.response?.data?.message;
        if (_.isArray(err)) {
          err.map((err) => message.error(err.message));
        } else {
          message.error(err || "Error updating category");
        }
      },
      retry: true,
    }
  );

  const postSubmit = (data) => {
    smallTalk
      .confirm(
        "Update Category",
        "You are about to update this category. Continue?",
        {
          buttons: {
            ok: "YES",
            cancel: "NO",
          },
        }
      )
      .then(() => mutateAsync(data));
  };

  if (isFetching) {
    return <div className="text-center p-4">Loading category details...</div>;
  }

  if (!category) {
    return (
      <div className="text-center p-4 text-danger">Category not found</div>
    );
  }

  return (
    <form onSubmit={handleSubmit(postSubmit)}>
      <div className="field">
        <label htmlFor="title">
          Title
          <RequiredIndicator />
        </label>
        <input
          type="text"
          id="title"
          autoFocus
          {...register("title", { required: true })}
          className="input w-100"
          placeholder="Enter category title"
        />
      </div>

      <div className="field">
        <label htmlFor="type">
          Type
          <RequiredIndicator />
        </label>
        <select
          id="type"
          {...register("type", { required: true })}
          className="input w-100">
          <option value="">Select category type</option>
          <option value="expense">Expense</option>
          {/* <option value="income">Income</option> */}
          <option value="service">Service</option>
          {/* <option value="support">Support</option> */}
        </select>
      </div>

      <div className="field">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          {...register("description")}
          className="textarea w-100"
          rows={4}
          placeholder="Enter category description"></textarea>
      </div>

      <div className="field mt-4">
        <button
          type="submit"
          className="button app-btn btn-prim w-100 p-2"
          disabled={isLoading}>
          {isLoading ? "Updating..." : "Update Category"}
        </button>
      </div>
    </form>
  );
}
